import PagedDataStore, { IFetchListArgs, IPagedData } from "../../../../stores/abstract-paged-data-store";
import WalletTransactionStore from "./wallet-transaction-store";
import { rootContainer, TYPE } from "../../../../services/container/root";
import WalletService, { IWalletTransaction } from "../../../../services/api/wallet-service";
import { makeObservable } from "mobx";

export class WalletBillingHistoryStore extends PagedDataStore<WalletTransactionStore>
{
    readonly perPage: number = 20;

    constructor() {
        super();
        makeObservable(this);
        this._sortBy = 'created_at';
        this._sortDir = 'desc';
    }

    protected get service(): WalletService {
        return rootContainer.get<WalletService>(TYPE.WalletService);
    }

    public async refresh(): Promise<void> {
        this.loadPage(this.page);
    }

    protected async fetchList(args: IFetchListArgs): Promise<IPagedData<WalletTransactionStore> | undefined> {
        const result = await this.service.fetchBillingHistory(args);

        return {
            ...result,
            data: result.data.map((walletTransaction: IWalletTransaction) =>
                new WalletTransactionStore(walletTransaction)
            )
        };
    }

}

export default new WalletBillingHistoryStore();